import { render } from "./JustoppHeader.vue?vue&type=template&id=23d14a52&scoped=true"
import script from "./JustoppHeader.vue?vue&type=script&lang=js"
export * from "./JustoppHeader.vue?vue&type=script&lang=js"

import "./JustoppHeader.vue?vue&type=style&index=0&id=23d14a52&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d14a52"]])

export default __exports__